<template>
  <Page>
    <template #title>Справочники</template>
    <BaseNavigation class="mb-6" :items="menu" />

    <PageContent>
      <div class="font-semibold mb-6">Просмотр заявок</div>

      <BaseTable :columns="columns" :items="items" :is-loading="isLoading">
        <template #column-status="item">
          <div class="flex flex-row items-center justify-between relative">
            {{ item.status }}
            <div class="absolute right-0 mt-1">
              <BaseButton
                v-if="item.answer && item.answer.length"
                variant="none"
                size="none"
                @click="showAnswer(item.answer)"
              >
                <BaseIcon name="info" width="26" height="26" />
              </BaseButton>
            </div>
          </div>
        </template>
      </BaseTable>

      <BasePagination
        class="my-6"
        :pagination="pagination"
        @paginate="onPaginate"
      />
    </PageContent>
  </Page>
</template>

<script>
  import {mapState} from 'vuex';

  import Page from '@/components/layouts/main/page';
  import BaseIcon from '@/components/global/base-icon';
  import BaseTable from '@/components/global/base-table';
  import BaseButton from '@/components/global/base-button';
  import BaseNavigation from '@/components/global/base-navigation';
  import BasePagination from '@/components/global/base-pagination';
  import PageContent from '@/components/layouts/main/page/PageContent';

  import {getCategoryNameById} from '@/utils/dictionaryCategories';

  export default {
    name: 'DictionaryListPage',

    components: {
      Page,
      BaseIcon,
      BaseTable,
      BaseButton,
      PageContent,
      BaseNavigation,
      BasePagination,
    },

    data() {
      return {
        isLoading: false,

        menu: [
          {
            name: 'Заявка на добавление',
            link: 'dictionary.request',
          },
          {
            name: 'Просмотр заявок',
            link: 'dictionary.list',
          },
          {
            name: 'Условия',
            link: 'condition.list',
          },
        ],

        columns: [
          {
            name: 'Дата',
            slug: 'created_at',
          },
          {
            name: 'Номер',
            slug: 'id',
          },
          {
            name: 'Справочник',
            slug: 'dictionary',
          },
          {
            name: 'Значение',
            slug: 'value',
          },
          {
            name: 'Статус',
            slug: 'status',
          },
        ],
      };
    },

    computed: {
      ...mapState('DictionaryRequestList', ['requests', 'pagination']),

      items() {
        let result = [];
        for (let i in this.requests) {
          let request = Object.assign({}, this.requests[i]);
          request.dictionary = getCategoryNameById(request.dictionary);
          result.push(request);
        }

        return result;
      },
    },

    created() {
      this.isLoading = true;
      let page = this.$route.query.page ?? 1;

      this.$store.dispatch('DictionaryRequestList/load', page).finally(() => {
        this.isLoading = false;
      });
    },

    destroyed() {
      this.$store.dispatch('DictionaryRequestList/clear');
    },

    beforeRouteUpdate(to, from, next) {
      this.$store.dispatch('DictionaryRequestList/load', to.query.page);
      next();
    },

    methods: {
      onPaginate(page) {
        this.$router.push({
          name: 'dictionary.list',
          query: {
            page: page,
          },
        });
      },

      showAnswer(answer) {
        this.$store.commit('Notification/showAlert', {
          title: 'Ответ оператора',
          message: answer,
        });
      },
    },
  };
</script>
